









































































































import Component from 'vue-class-component';
import BaseComponent from '../../../core/base.component';
import { NoticeBoardDto } from '../../../dto';
import NoticeBoardService from '../../../services/notice-board.service';
import { FileAttachmentDto } from '../../../services/shared/file-upload/dto';
import toast from '../../../../resources/assets/js/services/toast.js';
import NoticeBoardUpdate from '../../../modules/notice-board/components/NoticeBoardUpdate.vue';
import { ClearOutQueryParamMapper, ReverseQueryParamMapper } from '@/core';

@Component({
  name: 'NoticeBoardDetail',
  components: {
    NoticeBoardUpdate,
  },
})
export default class NoticeBoardDetail extends BaseComponent {
  private noticeBoardDto = new NoticeBoardDto();
  private editMode = false;

  getLinkUrl(linkUrl: string) {
    return linkUrl.includes('//') ? linkUrl : `//${linkUrl}`;
  }

  findOne(id) {
    NoticeBoardService.findOne(id).subscribe(res => {
      if (res) {
        this.noticeBoardDto = res.data;
      }
    });
  }

  deleteOne() {
    NoticeBoardService.deleteOne(this.$route.params.id).subscribe(res => {
      if (res) {
        toast.success('삭제 완료');
        this.$router.push('/notice-board');
      }
    });
  }

  update() {
    if (!this.$route.params.query) {
      this.editMode = true;
      this.$router.push({ query: { editMode: '1' } });
    }
  }

  cancelUpdate() {
    if (this.editMode) {
      this.editMode = false;
      ClearOutQueryParamMapper();
    }
  }

  created() {
    const query = ReverseQueryParamMapper(location.search);
    if (query) {
      this.editMode = Boolean(query.editMode);
    }
    const id = this.$route.params.id;
    this.findOne(id);
  }
}
